import React from "react";
import { DataTable } from "primereact/datatable";
import { DashboardEditorProps } from "components/ComponentType";
import { Column, ColumnEditorOptions } from "primereact/column";
import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { SankeyDiagramLink, SankeyDiagramProps } from "../sankey-types";

interface RowEditEvent {
  newData: RowData;
  data: RowData;
  index: number;
  originalEvent: React.SyntheticEvent;
}

interface RowData {
  identifier: string;
  source: string;
  target: string;
  customDivider?: number;
  customUnit?: string;
}

const LinksEditor = ({ config, onConfigChange }: DashboardEditorProps<SankeyDiagramProps>) => {

  const onRowEditComplete = (e: RowEditEvent) => {
    const linksToUpdate = [...config.graph.links!];
    const { newData } = e;
    const updatedLinks = linksToUpdate.map(link => {
      if (link.identifier === newData.identifier) {
        return { ...link, ...newData };
      }
      return link;
    });

    const updatedConfig = {
      ...config,
      graph: { ...config.graph, links: updatedLinks },
    };
    onConfigChange(updatedConfig);
  };

  const renderTitle = (rowData: SankeyDiagramLink) => {
    return <DatasetTitle identifier={rowData.identifier} />;
  };

  const textEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        value={options.value as string || ""}
        onChange={e => options.editorCallback && options.editorCallback(e.target.value as string)}
        style={{ width: "100%" }}
      />
    );
  };

  const numberEditor = (options: ColumnEditorOptions) => {
    return (
      <InputNumber
        inputStyle={{ width: "100%", height: "100%" }}
        value={options.value as number}
      onChange={e => options.editorCallback && options.editorCallback(e.value as number)}
      />
    );
  };

  const dropdownEditor = (options: ColumnEditorOptions) => {
    const nodes = config.graph.nodes || [];

    return (
      <Dropdown
        value={options.value}
        options={nodes}
        onChange={e => options.editorCallback && options.editorCallback(e.value as string)}
        style={{ width: "100%" }}
      />
    );
  };

  return (
    <DataTable
      value={config.graph.links}
      onRowEditComplete={onRowEditComplete}
      editMode="row"
      dataKey="id"
    >
      <Column field="identifier" header="Identifier" body={renderTitle} />
      <Column field="source" header="Source" editor={dropdownEditor} />
      <Column field="target" header="Target" editor={dropdownEditor} />
      <Column field="customUnit" header="Unit" editor={textEditor} />
      <Column field="customDivider" header="Divider" editor={numberEditor} />
      <Column rowEditor align="center" style={{ width: "10%" }} />
    </DataTable>
  );
};

export default LinksEditor;